<template>
  <div
    :class="['hint', placement, { active: show }]"
    tabindex="0"
    @touchstart.stop="show = !show"
    @mouseleave="show = false"
    @click.stop=""
  >
    <div class="img" @mouseenter="show = true" />

    <div v-if="show" class="dropdown">
      <div class="content">
        <RenderHTML v-if="text" tag-wrapper="p" :seotext="text" />
        <slot v-else />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import RenderHTML from '~/components/ui/RenderHTML.vue';

export default defineComponent({
  name: 'Hint',
  components: { RenderHTML },
  props: {
    text: { type: String, default: '' },
    placement: {
      type: String,
      default: 'top-end',
      validator: (value: string) =>
        [
          'top-start',
          'top',
          'top-end',
          'left-start',
          'left',
          'left-end',
          'right-start',
          'right',
          'right-end',
          'bottom-start',
          'bottom',
          'bottom-end',
        ].includes(value),
    },
  },
  emits: ['visible'],
  setup(_, { emit }) {
    const show = ref<boolean>(false);
    const visible = watch(
      () => show.value,
      (show) => show && emit('visible')
    );

    return { show, visible };
  },
});
</script>
<style lang="scss" src="./HintScss.scss" scoped></style>
